const straightRun = (path, x, y, bow = 0) => {
  const fromX = path.currentPoint.x;
  const fromY = path.currentPoint.y;
  path.quadraticCurveTo((fromX + x) / 2, (fromY + y) / 2 + bow, x, y);
};
export {
  straightRun
};
